import { protectedResources } from "../context/AuthContext/authConfig";
import { Topic } from "../context/ConfigContext/types";
import {
  CreateLabelValueBody,
  CreateOrUpdateConfigBody,
  CreateOrUpdateOptionValue,
  Endpoint,
  EndpointsWithActiveFlag,
  FetchResponse,
  RequestType,
  UpdateMainUserResponse,
} from "./types";
import { apiRequest } from "./helpers";
import { UserWithClients } from "../context/ClientAccessContext/types";

export const updatePossibleLabelValue = async (reqBody: CreateLabelValueBody) => {
  const url = protectedResources.scraperAPI.endpoint + Endpoint.LABEL_VALUES;
  return apiRequest(RequestType.POST, url, reqBody) as Promise<FetchResponse<number>>;
};

export const updateClientUser = async (userId: number, reqBody: CreateLabelValueBody) => {
  const url = protectedResources.scraperAPI.endpoint + Endpoint.CLIENT_USERS + "/" + userId;
  return apiRequest(RequestType.PUT, url, reqBody) as Promise<FetchResponse<number>>;
};

export const updateMainUser = async (userId: number, reqBody: UserWithClients) => {
  const url = `${protectedResources.scraperAPI.endpoint}${Endpoint.MAIN_USERS}/${userId}`;
  return apiRequest(RequestType.PUT, url, reqBody) as Promise<FetchResponse<UpdateMainUserResponse>>;
};

export const updateTopic = async (reqBody: Topic) => {
  const url = protectedResources.scraperAPI.endpoint + Endpoint.TOPICS;
  return apiRequest(RequestType.PUT, url, reqBody) as Promise<FetchResponse<number>>;
};

export const updateOptionValue = async (optionValueId: number, reqBody: CreateOrUpdateOptionValue) => {
  const url = protectedResources.scraperAPI.endpoint + Endpoint.CONFIG_OPTION_VALUE + "/" + optionValueId;
  return apiRequest(RequestType.PUT, url, reqBody) as Promise<FetchResponse<number>>;
};

export const updateScraperConfig = async (configId: number, reqBody: CreateOrUpdateConfigBody) => {
  const url = protectedResources.scraperAPI.endpoint + Endpoint.CONFIG + "/" + configId;
  return apiRequest(RequestType.PUT, url, reqBody) as Promise<FetchResponse<number>>;
};

export const updateActiveFlag = async (endpoint: EndpointsWithActiveFlag, itemId: number, active: boolean) => {
  const url = `${protectedResources.scraperAPI.endpoint}${endpoint}/${itemId}/${active}`;
  return apiRequest(RequestType.PATCH, url, null) as Promise<FetchResponse<number>>;
};
